import React, { useRef } from 'react'
import Dropdown from '../Dropdown'
import { PLACEMENT } from '../utils/constant'
import PropTypes from 'prop-types'

const PopoverContent = ({ children, closeRef }) => {
  const close = () => closeRef.current?.()
  const content =
    typeof children === 'function' ? children({ close }) : children
  return content
}

const Popover = ({ children, className, menuClass, renderTitle, ...rest }) => {
  const closeRef = useRef(null)
  return (
    <Dropdown
      trigger="click"
      placement={PLACEMENT.BOTTOM_START}
      renderTitle={renderTitle}
      menuClass={menuClass}
      registerClose={(fn) => {
        closeRef.current = fn
      }}
      {...rest}
    >
      <Dropdown.Item
        variant="custom"
        className="!p-0 !block border-0"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="min-w-[200px]"
          onClick={(e) => e.stopPropagation()}
          role="presentation"
        >
          <PopoverContent closeRef={closeRef}>{children}</PopoverContent>
        </div>
      </Dropdown.Item>
    </Dropdown>
  )
}

Popover.propTypes = {
  children: (props, propName, componentName) => {
    const prop = props[propName]
    if (prop == null) return null
    if (typeof prop === 'function') return null
    return PropTypes.node(props, propName, componentName)
  },
  className: PropTypes.string,
  menuClass: PropTypes.string,
  renderTitle: PropTypes.node,
}

export default Popover
